import { OrderItemSerializable } from './order-item-serializable';

export class SfdcCashCreditTransferOrderItemSerializable extends OrderItemSerializable {
  sfdcCashCreditTransfer: number = null;
}
